module.exports = '<svg width="36" height="32" viewBox="0 0 36 32"><path d="M10.812 0h-.536c-.296 0-.924.218-1.408.484L1.18 4.758C.196 5.336-.264 6.53.156 7.594l2.62 6.55c.418 1.064 1.75 1.476 2.774.964L8 13.932v16.554C8 31.628 8.598 32 9.742 32h16.554C27.442 32 28 31.628 28 30.486V13.932l2.47 1.144c1.024.51 2.284.064 2.702-1l2.666-6.622c.42-1.064-.018-2.12-1.002-2.698L27.17.484C26.688.218 26.056 0 25.762 0h-.536c-.552 0-.992.462-1.208.97-.706 1.666-3.118 3.168-5.998 3.168S12.726 2.636 12.022.97c-.218-.508-.656-.97-1.21-.97z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/shirt-1.js
// module id = 1412
// module chunks = 14